exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "installation-guide ul li h3:after{content:none!important}installation-guide a.button.link{border-top:none;font-size:.9em;width:auto;margin:1.3em 0 2.5em;padding:0 .8em}installation-guide a.button.link:after{color:#000!important}installation-guide a.button.link:focus span,installation-guide a.button.link:hover span{text-decoration:underline}installation-guide p{text-align:justify}installation-guide p.downloadLinks{width:100%;text-align:center}@media (max-width:1023px){installation-guide a.button.link{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/installation/installation-guide/installation-guide.styl
// module id = 886
// module chunks = 0